import { render, staticRenderFns } from "./CompTeacherLists.vue?vue&type=template&id=21767fcc"
import script from "./CompTeacherLists.vue?vue&type=script&lang=js"
export * from "./CompTeacherLists.vue?vue&type=script&lang=js"
import style0 from "./CompTeacherLists.vue?vue&type=style&index=0&id=21767fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports